import React from 'react';

import {
  ClassName,
  IsDisabled,
  IsOptimisticUpdate
} from '../../../../../../../types';

import {
  MaterialsSetSelectedMaterialsID,
  UpdateMaterialsSetCacheAction
} from '../../../../../../materialsSets/materialsSetsTypes';

import { SelectedMaterialsSidebarAttachModalButtonMaterialsSet } from './SelectedMaterialsSidebarAttachModalButton.types';

import { useSelectedMaterialsSidebarAttachModalButton } from './hooks/useSelectedMaterialsSidebarAttachModalButton';

import { SelectProjectAndTaskModalButton } from '../../../../../../common/components/modalButtons/SelectProjectAndTaskModalButton';

import { words, materialsKeys } from '../../../../../../../locales/keys';

interface SelectedMaterialsSidebarAttachModalButtonProps {
  selectedMaterialIds: MaterialsSetSelectedMaterialsID[];
  optimisticUpdate?: IsOptimisticUpdate;
  onClose: () => void;
  updateMaterialsSetCache: UpdateMaterialsSetCacheAction<SelectedMaterialsSidebarAttachModalButtonMaterialsSet>;
  className: ClassName;
  disabled?: IsDisabled;
}

function SelectedMaterialsSidebarAttachModalButton({
  selectedMaterialIds,
  optimisticUpdate,
  onClose,
  updateMaterialsSetCache,
  className,
  disabled
}: SelectedMaterialsSidebarAttachModalButtonProps) {
  const { isLoading, errorMessage, handleSubmit, handleClose } =
    useSelectedMaterialsSidebarAttachModalButton({
      selectedMaterialIds,
      onClose,
      updateMaterialsSetCache
    });

  return (
    <SelectProjectAndTaskModalButton
      dataGa="selected-materials-set-attach-modal-button"
      className={className}
      i18nText={words.attach}
      i18nSubmitText={words.attach}
      i18nTitle={materialsKeys.attachSelected}
      isLoading={isLoading}
      submitDisabled={optimisticUpdate}
      errorMessage={errorMessage}
      onClose={handleClose}
      onSubmit={handleSubmit}
      disabled={disabled}
    />
  );
}

export default SelectedMaterialsSidebarAttachModalButton;
